import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Home from "./pages/Home";
import Tour from "./pages/Tour";
import Tourdetails from "./pages/Tourdetails";

function App() {
  return (
    <Router>
      <Routes>

        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />    
          <Route path="/tour" element={<Tour />} />  
                    <Route path="/tourdetails" element={<Tourdetails />} />  
                    <Route path="/tourdetails/:id" element={<Tourdetails />} />  

        <Route path="/contact" element={<Contact />} />

      </Routes>
    </Router>
  );
}

export default App;